export default "__VITE_ASSET__U6zx02gu__"